<template>
  <div>
    <ul
      class="c-footerGuideSublist"
      v-if="footerContent.sub.length"
    >
      <li
        class="c-footerGuideSublist_list"
        v-for="(footerContentSub, index) in footerContentSubActive"
        :key="`${footerContent.name}_${index}`"
      >
        <a
          :href="genLink(footerContentSub)"
          :target="genLinkTarget(footerContentSub.url_type)"
        >
          {{ footerContentSub.text }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
const TARGET_BLANK_LIST = ['corporate', 'other_service', 'external']

export default {
  props: {
    footerContent: {
      type: Object,
      default: () => {}
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    isBusinessFooter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapState('auth/user', ['isBusiness', 'id']),
    footerContentSubActive() {
      const condition = []
      // 表示条件が追加され次第拡張していく
      if (this.isPC) {
        condition.push('onlyPc')
      }
      // ビジネスアカウントまたはビジネスプレビュー時に表示
      if (this.isBusinessFooter) {
        condition.push('onlyBusiness')
      } else {
        // ビジネスじゃない場合は個人用の表示
        condition.push('onlyPrivate')
      }
      return this.footerContent.sub.filter(
        sub => !sub.condition || sub.condition.every(item => condition.includes(item))
      )
    },
    isBusinessPreview() {
      return this.$route.path === '/business/top' || !!this.$route.query.is_business
    }
  },
  methods: {
    genLink(content) {
      let url = content.url
      if (this.isLoggedIn && content.url_is_login) {
        url = content.url_is_login
      }
      if (content.url_type === 'coconala') {
        // ビジネスプレビュー中は対象のリンクをビジネスプレビュー状態で遷移させる
        if (this.isBusinessPreview && content.isBusinessPreviewable) {
          return this.$coconala.url(url, { is_business: '1' })
        }
        return this.$coconala.url(url)
      }
      return url
    },
    genLinkTarget(url_type) {
      if (TARGET_BLANK_LIST.indexOf(url_type) >= 0) {
        return '_blank'
      }
      return '_self'
    }
  }
}
</script>
